"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselPrevious = exports.CarouselNext = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _Clickable = require("../Clickable");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ARROW_WIDTH = [2, 4];
var ARROW_TRANSITION_MS = 250;
/** CarouselNavigationProps */

var Arrow = (0, _styledComponents.default)(_Clickable.Clickable).withConfig({
  displayName: "CarouselNavigation__Arrow",
  componentId: "sc-16jrffs-0"
})(["position:absolute;top:0;display:flex;align-items:center;justify-content:center;cursor:pointer;user-select:none;transition:opacity ", "ms,color ", "ms;> svg{fill:currentColor;}&:hover,&:focus{outline:0;color:", ";}&:disabled{opacity:0;cursor:default;}"], ARROW_TRANSITION_MS, ARROW_TRANSITION_MS, (0, _helpers.color)("black100"));
/**
 * Set some easily overwriteable props using `defaultProps`
 */

Arrow.defaultProps = {
  width: ARROW_WIDTH.map(function (value) {
    return (0, _helpers.space)(value);
  }),
  height: "100%",
  color: "black60"
};
/**
 * Default next button
 */

var CarouselNext = (0, _styledComponents.default)(Arrow).withConfig({
  displayName: "CarouselNavigation__CarouselNext",
  componentId: "sc-16jrffs-1"
})(["right:0;transform:translateX(100%);"]);
/**
 * Default previous button
 */

exports.CarouselNext = CarouselNext;
var CarouselPrevious = (0, _styledComponents.default)(Arrow).withConfig({
  displayName: "CarouselNavigation__CarouselPrevious",
  componentId: "sc-16jrffs-2"
})(["left:0;transform:translateX(-100%);"]);
exports.CarouselPrevious = CarouselPrevious;